<template>
    <button class="flex gap-1 text-[#999700] items-center" @click="repeatOrder(props.orderId)">Повторить <img src="~/assets/icon/icon-repeat.svg" alt=""></button>
</template>

<script setup lang="ts">
import { useFillFromOrder } from '~/composables/api/basket'
import { useProfileDialogStore } from '~/store/profileDialog'
import { ref } from 'vue'
import { useCartDialogStore } from '~/store/cartDialog'
import { useToast } from 'vue-toastification'
import MyToast from '~/components/MyToast.vue'
import { useAlertDialogStore } from '~/store/alertDialog'
const props = defineProps<{
    orderId: number
}>()

const emit = defineEmits(['repeatOrder'])

const showNotDeliveringMessage = ref(false)
let errorMessage = ""

const { mutate } = useFillFromOrder()
const profileDialogStore = useProfileDialogStore()
const toast = useToast()

const cartDialogStore = useCartDialogStore()
const alertDialogStore = useAlertDialogStore()

const repeatOrder = (orderId: number) => {
    emit('repeatOrder')

    mutate(orderId, {
        onSuccess: (response, variables, context) => {

            toast({
                component: MyToast,
                props: {
                    title: 'Повтор заказа',
                    detail: 'Добавили в корзину блюда из выбранного заказа',
                },
            })
            /*
            cartDialogStore.open()

            if(!response?.data?.all_items_available) {
                alertDialogStore.open("Не удается повторить заказ", "Некоторые блюда из выбранного заказа недоступны в данный момент в выбранном ресторане. Эти блюда не удалось добавить в корзину")
            }*/
        },
    })
}
</script>
